<template>
  <q-card
    v-for="(item, index) in accounting_details"
    :key="index"
    class="full-width q-mt-lg"
  >
    <q-timeline
      color="secondary"
      class="accounting-details-timeline q-pa-md q-my-none text-caption"
    >
      <!-- schemas d'ecritures -->
      <q-timeline-entry
        v-for="(entry, entryIndex) in item"
        :key="`entry_${index}_${entryIndex}`"
        class="q-pb-none"
      >
        <template v-slot:subtitle>
          <span v-if="entryIndex == 0"> {{ entry.ecr_lib }}</span>
        </template>

        <q-separator
          v-if="entryIndex == 1"
          class="q-mb-md"
          style="position: relative; top: 11px;"
        />


        <!-- Journal -->
        <q-item class="q-px-none">
          <q-item-section>
            <q-item-label class="text-bold">
              {{ i18n.transaction_details_accounting_ae_journal }}
            </q-item-label>
            <q-item-label>
              {{ entry.journal_code }} - {{ entry.journal_lib }}
            </q-item-label>
          </q-item-section>
        </q-item>

        <!-- Compte débit -->
        <q-item
          v-if="entry.debit_amount > 0"
          class="q-px-none"
        >
          <q-item-section>
            <q-item-label class="text-bold">
              {{ i18n.transaction_details_accounting_ae_debit_account }}
            </q-item-label>
            <q-item-label>
              {{ entry.account_num }} - {{ entry.account_lib }}
            </q-item-label>
          </q-item-section>
        </q-item>

        <!-- Compte crédit -->
        <q-item
          v-if="entry.credit_amount > 0"
          class="q-px-none"
        >
          <q-item-section>
            <q-item-label class="text-bold">
              {{ i18n.transaction_details_accounting_ae_credit_account }}
            </q-item-label>
            <q-item-label>
              {{ entry.account_num }} - {{ entry.account_lib }}
            </q-item-label>
          </q-item-section>
        </q-item>

        <!-- Debit Amount -->
        <q-item
          v-if="entry.debit_amount > 0"
          class="q-px-none"
        >
          <q-item-section>
            <q-item-label class="text-bold">
              {{ i18n.transaction_details_accounting_ae_amount }}
            </q-item-label>
            <q-item-label>
              {{ entry.debit_amount_formatted }} ({{ entry.currency_amount }})
            </q-item-label>
          </q-item-section>
        </q-item>

        <!-- Credit Amount -->
        <q-item
          v-if="entry.credit_amount > 0"
          class="q-px-none"
        >
          <q-item-section>
            <q-item-label class="text-bold">
              {{ i18n.transaction_details_accounting_ae_amount }}
            </q-item-label>
            <q-item-label>
              {{ entry.credit_amount_formatted }} ({{ entry.currency_amount }})
            </q-item-label>
          </q-item-section>
        </q-item>

        <!-- entry.CompteAuxNum -->
        <q-item
          v-if="entry.CompteAuxNum"
          class="q-px-none"
        >
          <q-item-section>
            <q-item-label class="text-bold">
              CompteAuxNum - CompteAuxLib
            </q-item-label>
            <q-item-label>
              {{ entry.CompteAuxNum }} - {{ entry.CompteAuxLib }}
            </q-item-label>
          </q-item-section>
        </q-item>
      </q-timeline-entry>
    </q-timeline>
  </q-card>
</template>

<script>
export default {
  name: 'AccountingEntries',
  props: {
    i18n: {
      type: Object,
      required: true,
    },
    accounting_details: {
      type: Array,
      required: false,
      default: () => [],
    },
  },
  data() {
  },
}
</script>
